import { render, staticRenderFns } from "./JdsListItem.vue?vue&type=template&id=5f0a2091&scoped=true&"
import script from "./JdsListItem.vue?vue&type=script&lang=ts&"
export * from "./JdsListItem.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f0a2091",
  null
  
)

export default component.exports